/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[alphaSpecial]' })
export class AlphaSpecialDirective {
	inputElement!: HTMLInputElement;
	private navigationKeys = [
		'Backspace',
		'Delete',
		'Tab',
		'Escape',
		'Enter',
		'Home',
		'End',
		'ArrowLeft',
		'ArrowRight',
		'Clear',
		'Copy',
		'Paste'
	];

	constructor(public el: ElementRef) {
		this.inputElement = el.nativeElement;
	}

	@HostListener('keypress', ['$event'])
	onKeyPress(e: KeyboardEvent): any {
		// debugger;
		if (this.navigationKeys.indexOf(e.key) > -1) {
			// let it happen, don't do anything
			return;
		}

		if (this._validateText(e.key)) {
			return true;
		} else {
			e.preventDefault();
			return false;
		}
	}

	@HostListener('paste', ['$event'])
	onPaste(event: any): any {
		let pastedInput = '';
		if ((window as { [key: string]: any })['clipboardData']) {
			// Browser is IE
			pastedInput = (window as { [key: string]: any })['clipboardData'].getData('text');
		} else if (event.clipboardData && event.clipboardData.getData) {
			// Other browsers
			pastedInput = event.clipboardData.getData('text/plain');
		}

		if (this._validateText(pastedInput)) {
			return true;
		}

		event.preventDefault();
		return false;
	}

	//permite letras , punto (".") y ampersand ("&")
	private _validateText(text: string): boolean {
		return /[a-zA-Z0-9. ]/.test(text);
	}
}
